import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { csrfToken } from '@/util/helpers/ajax-helpers';

// NOTE: this needed as long as we are migrating our endpoint to api/v1
export const configureBaseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    credentials: 'same-origin',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json;charset=UTF-8');
      headers.set('x-requested-with', 'XMLHttpRequest');

      const token = csrfToken();
      if (token) headers.set('x-csrf-token', token);

      return headers;
    },
  });

export const baseQuery = configureBaseQuery('/api/v1/');

// NOTE: this needed as long as we are migrating our endpoint to api/v1
export const baseQuery_LEGACY = configureBaseQuery('/');
